module.exports = __webpack_public_path__ + "static/media/pop-up-banner.d57c1013.png";